import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { LoanType } from 'src/api/zrm';
import FormStepperSubStepsContainer from 'src/components/Stepper/subSteps/FormStepperSubStepsContainer';

import SharedNorwayLoansSection from './SharedNorwayLoansSection';

interface SharedNorwayLoansStepProps {
}

const SharedNorwayLoansStep: FC<SharedNorwayLoansStepProps> = () => {
  const { t } = useTranslation();

  return (
    <FormStepperSubStepsContainer
      stepsInOrder={[
        <SharedNorwayLoansSection
          formKey='carLoan'
          index={1}
          title='Do you have a car loan?'
          key='carLoan'
          loanType={LoanType.CAR_LOAN}
          itemTitle={t('Car Loan')}
        />,
        <SharedNorwayLoansSection
          formKey='mortgageLoan'
          index={2}
          title='Do you have a mortgage loan?'
          key='mortgageLoan'
          loanType={LoanType.MORTGAGE}
          itemTitle={t('Mortgage Loan')}
        />,
        <SharedNorwayLoansSection
          formKey='otherLoan'
          index={3}
          title='Do you have any other loan?'
          key='otherLoan'
          loanType={LoanType.OTHER}
          itemTitle={t('Other Loan')}
        />,
      ]}
    />
  );
};


export default SharedNorwayLoansStep;
